// A serializer 400 carries the message under the field key, not under detail.
const firstFieldError = (response) =>
  response && typeof response === 'object'
    ? Object.values(response)
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .find((value) => typeof value === 'string' && value) || null
    : null

export const vendorErrorMessage = (error, fallback) => {
  if (error?.status === 403) return 'You do not have permission to manage vendors.'
  const detail = error?.detail ?? error?.response?.detail
  if (typeof detail === 'string' && detail) return detail
  return firstFieldError(error?.response) || fallback
}
